(() => {
  function initializeHeader(header) {
    const search = header.querySelector('.header-search');
    const menu = header.querySelector('.menu-button');
    const nav = header.querySelector('.main-nav');
    if (!search || search.dataset.initialized) return;
    search.dataset.initialized = 'true';
    search.addEventListener('toggle', () => {
      if (!search.open) return;
      if (nav && menu) {
        nav.classList.remove('open');
        menu.setAttribute('aria-expanded', 'false');
        menu.textContent = '☰';
      }
      search.querySelector('input[type="search"]').focus();
    });
    if (menu) menu.addEventListener('click', () => { search.open = false; });
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && search.open) {
        search.open = false;
        search.querySelector('summary').focus();
      }
    });
  }
  document.querySelectorAll('.site-header').forEach(initializeHeader);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.site-header').forEach(initializeHeader);
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.header-search[open]').forEach((search) => {
      if (!search.contains(event.target)) search.open = false;
    });
  });
})();
